import React, { useState, useEffect, useRef, useMemo } from 'react'
import { useFormContext } from 'react-hook-form'

import { Lang, Country } from '../../types/common-types'
import { State } from '../../state-actions-reducers'
import TextInput from '../../shared/Inputs/TextInput/TextInput'
import PhoneInput from '../../shared/Inputs/PhoneInput/PhoneInput'
import styles from './ScreenTwo.module.scss'
import warningImage from '../../images/warning.svg'
import SocialLinksInput from '../../shared/Inputs/SocialLinksInput/SocialLinksInput'
import MessengersInput from '../../shared/Inputs/MessengersInput/MessengersInput'
import { checkPhoneEmail } from '../../hooks/useCheckPhoneEmailCustomHook'
import useDebounce from '../../utils/useDebounce'
import OccupationInputs from './OccupationInputs/OccupationInputs'
import AnotherRentalsInputs from '../../shared/Inputs/AnotherRentalsInputs/AnotherRentalsInputs'
import InfoMessage from '../../shared/InfoMessage/InfoMessage'

interface Props {
  lang: Lang
  accountForm: any
  allCitizenships: Country[]
}

/* THE COMPONENT */
function ScreenTwo({
  lang,
  accountForm,
  allCitizenships,
}: Props) {
  const { watch, setValue, formState: { errors } } = useFormContext<State>()
  const state = watch()

  const countriesRef = useRef(
    allCitizenships?.reduce(
      (object, country) => ({
        ...object,
        [country.alpha2 as any]: (country as any)[lang],
      }),
      {}
    )
  )
  const debouncedPhone = useDebounce(state.mobilePhoneNumbers[0], 1500)
  const debouncedMail = useDebounce(state.emails[0], 1500)

  function handleServerError() {
    setValue('serverError', true, { shouldDirty: true });
    alert(accountForm.serverError[lang]);
  }

  async function phoneMessage() {
    try {
      let response = await checkPhoneEmail(state, debouncedPhone, debouncedMail)
      if (response.message !== 'Invalid token') {
        setValue('isPhoneOk', response.isPhoneOk, { shouldDirty: true })
      } else {
        handleServerError()
      }
    } catch (err) {
      handleServerError()
    }
  }
  async function emailMessage() {
    try {
      let response = await checkPhoneEmail(state, debouncedPhone, debouncedMail)
      if (response.message !== 'Invalid token') {
        setValue('isEmailOk', response.isEmailOk, { shouldDirty: true })
      } else {
        handleServerError()
      }
    } catch (err) {
      handleServerError()
    }
  }
  useEffect(() => {
    if (debouncedPhone && debouncedPhone.length > 2) {
      phoneMessage()
    } else {
      setValue('isPhoneOk', true, { shouldDirty: true })
    }
  }, [debouncedPhone])
  useEffect(() => {
    if (debouncedMail) {
      emailMessage()
    } else {
      setValue('isEmailOk', true, { shouldDirty: true })
    }
  }, [debouncedMail])
  
  return (
    <>
      <main className={styles.main}>
        <div className="form-group">
          <div className="row">
            <div className="col-12 col-xs-12">
              <h3>{accountForm.stepTwoContactsTitle[lang]}</h3>
            </div>
          </div>
          <div className='row'>
            <div className="col-4 col-xs-12">
              <PhoneInput
                testName="contactPhoneSeconds"
                testErrorName="error-contactPhoneSeconds"
                label={accountForm.additionalPhoneNumbers.label[lang]}
                lang={lang}
                numbers={
                  state.contactPhoneSeconds.length === 0
                    ? ['']
                    : state.contactPhoneSeconds
                }
                setNumbers={data => {
                  setValue('contactPhoneSeconds', data, { shouldDirty: true })
                }}
                valid={!errors.contactPhoneSeconds}
              />
            </div>
            <div className="col-4 col-xs-12">
              <TextInput
                testName="personalWebsite"
                testErrorName="error-personalWebsite"
                lang={lang}
                content={accountForm.personalWebsite}
                value={state.personalWebsite[0]}
                onChange={data => (
                  setValue('personalWebsite', [data], { shouldDirty: true }),
                  console.log(state.personalWebsite)
                )}
                valid={!errors.personalWebsite}
              />
            </div>
            <InfoMessage type='default' text={accountForm.additionalPhoneMessage[lang]} />
          </div>
        </div>
        <MessengersInput
          lang={lang}
          allCitizenships={allCitizenships}
          phoneNumbers={state.mobilePhoneNumbers}
        />
        <SocialLinksInput
          lang={lang}
          accountForm={accountForm}
        />
        <OccupationInputs
          lang={lang}
          accountForm={accountForm}
        />
        <AnotherRentalsInputs
          lang={lang}
          accountForm={accountForm}
        />
        <div className="form-group">
          <div className="row">
            <div className="col-12 col-xs-12">
              <h3>{accountForm.stepTwoRecomendation[lang]}</h3>
            </div>
            <div className="col-6 col-xs-12">
              <TextInput
                testName="recommendations"
                testErrorName="error-recommendations"
                lang={lang}
                content={accountForm.recommendations}
                value={state.recommendations}
                onChange={data =>
                  setValue('recommendations', data, { shouldDirty: true })
                }
                tooltip={accountForm.recommendationsTooltip[lang]}
                valid={!errors.recommendations}
                required
              />
            </div>
            <div className="col-12 col-xs-12">
              <p className={styles.warningMessage}>
                <img src={warningImage} alt="warningImage"></img>
                {accountForm.stepRecomendationWarning[lang]}
              </p>
            </div>
          </div>
        </div>
      </main>
    </>
  )
}

export default ScreenTwo
